// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"trainerH5_wrapper_Yr79y","img":"trainerH5_img_2qtPu"};